import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectDetailsPageEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-project-details-page-entrypoint" */ './ProjectDetailsPage.tsx'
			),
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
